import React, { useState } from 'react';

// Renders /logo.png if present, otherwise an inline gold hexagon "E" so the
// app always looks branded even before you drop the logo file in /public.
export default function Logo({ size = 34, withWordmark = false }) {
  const [failed, setFailed] = useState(false);

  return (
    <div className="brand">
      {failed ? (
        <HexMark size={size} />
      ) : (
        <img
          src="/logo.png"
          alt="Evitta"
          style={{ height: size }}
          onError={() => setFailed(true)}
        />
      )}
      {withWordmark && <span className="name gold-text">EVITTA</span>}
    </div>
  );
}

function HexMark({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden="true">
      <defs>
        <linearGradient id="gold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#f9d423" />
          <stop offset="100%" stopColor="#e6a817" />
        </linearGradient>
      </defs>
      <polygon
        points="50,4 92,27 92,73 50,96 8,73 8,27"
        fill="#0a0e1a"
        stroke="url(#gold)"
        strokeWidth="6"
      />
      <text
        x="50"
        y="68"
        textAnchor="middle"
        fontFamily="Sora, sans-serif"
        fontWeight="800"
        fontSize="52"
        fill="url(#gold)"
      >
        E
      </text>
    </svg>
  );
}
